// Copyright (c) 2016 Deere & Company

import PipDetailsContainer from '../../pip/pip-details/state-connector';

export default {
    component: PipDetailsContainer,
    name: 'PIP_DETAILS',
    path: 'programs/:pipId'
};



// WEBPACK FOOTER //
// ./src/routes/pips/pip-details.js